module.exports = __webpack_public_path__ + "img/续断.b9305eb4.jpg";